import { SET_PASSENGER_VALUES, SET_PASSENGERS_STATE } from './actions';
export const passengersReducer = (state = [], action) => {
    switch (action.type) {
        case SET_PASSENGERS_STATE:
            return action.payload;
        case SET_PASSENGER_VALUES:
            const valuesData = action.payload;
            return state.map((passenger, index) => (Object.assign(Object.assign({}, passenger), { values: index === valuesData.id ? valuesData.values : passenger.values })));
        /*case SET_PASSENGER_SERVICES:
            const servicesData = (action as SetPassengerServicesAction).payload;

            return state.map((passenger, index) => ({
                ...passenger,
                services:
                    index === servicesData.id
                        ? servicesData.services
                                .filter(service => service.count > 0)
                                .map(service => ({
                                    serviceId: service.serviceId,
                                    count: service.count,
                                    segmentIds: service.segmentIds,
                                    confirmedCount: service.confirmedCount
                                }))
                        : passenger.services
            }));

        case SET_PASSENGER_SEATS:
            const seatsData = (action as SetPassengerSeatsAction).payload;

            return state.map((passenger, index) => ({
                ...passenger,
                seats: index === seatsData.id ? seatsData.seats : passenger.seats
            }));*/
    }
    return state;
};
